import React from 'react';
import { MessageCircle, Instagram, Link2 } from 'lucide-react';
import { SOCIALS } from '../mock';
import { useReveal } from '../hooks/useReveal';

// Kick & X have no dedicated lucide icons — use inline SVGs.
const KickIcon = ({ size = 46 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" style={{ width: size, height: size, display: 'block' }}><path d="M3 2h5v6l4-6h6l-6 9 6 9h-6l-4-6v6H3z"/></svg>
);
const XIcon = ({ size = 46 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" style={{ width: size, height: size, display: 'block' }}><path d="M18.9 2H22l-7.3 8.3L23.3 22h-6.7l-5.2-6.9L5.4 22H2.3l7.8-8.9L1 2h6.9l4.7 6.3zM17.7 20h1.7L7.4 4H5.6z"/></svg>
);

const ICON = 46;

const CARDS = [
  { key: 'kick', label: 'KICK', sub: 'Watch my streams', cta: 'FOLLOW ME', href: SOCIALS.kick, Icon: KickIcon, color: '#53fc18', btnText: '#06130a' },
  { key: 'discord', label: 'DISCORD', sub: 'Chat with us', cta: 'JOIN US', href: SOCIALS.discord, Icon: MessageCircle, color: '#5865f2', btnText: '#ffffff' },
  { key: 'x', label: 'X', sub: 'Latest updates', cta: 'FOLLOW ME', href: SOCIALS.x, Icon: XIcon, color: '#ffffff', btnText: '#ffffff', btnBg: '#111318' },
  { key: 'instagram', label: 'INSTAGRAM', sub: 'Behind the scenes', cta: 'FOLLOW ME', href: SOCIALS.instagram, Icon: Instagram, color: '#e1306c', btnText: '#ffffff' },
  { key: 'beacons', label: 'BEACONS', sub: 'All my links', cta: 'VIEW ALL', href: SOCIALS.beacons, Icon: Link2, color: '#00D9FF', btnText: '#04121a' },
];

export default function Community() {
  useReveal();
  return (
    <section id="community" className="py-16 sm:py-24 relative">
      <div className="ar-container">
        <div className="text-center mb-12 sm:mb-16 reveal">
          <p className="ar-eyebrow mb-3">Community</p>
          <h2 className="ar-heading text-3xl sm:text-4xl md:text-5xl mb-4">Join The <span className="text-cyan glow-cyan">AsianRisk</span> Family</h2>
          <p className="text-muted max-w-2xl mx-auto">Follow along everywhere and never miss a stream, drop or giveaway.</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-12 items-stretch">
          {CARDS.map((c, i) => (
            <a
              key={c.key}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center text-center h-full reveal reveal-scale"
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              {/* Glowing brand icon — fixed-height box so all align */}
              <div
                className="h-16 flex items-center justify-center mb-4 transition-transform duration-300 group-hover:-translate-y-2 group-hover:scale-110"
                style={{ color: c.color, filter: `drop-shadow(0 0 22px ${c.color}99)` }}
              >
                <c.Icon size={ICON} />
              </div>

              {/* Big brand-colored title — fixed height */}
              <h3
                className="font-display font-bold text-2xl sm:text-3xl md:text-[2rem] leading-none mb-2 tracking-wide h-9 flex items-center"
                style={{ color: c.color, textShadow: `0 0 20px ${c.color}66` }}
              >
                {c.label}
              </h3>
              <p className="text-sm text-muted mb-6 h-5">{c.sub}</p>

              {/* Brand-colored button pinned to bottom */}
              <span
                className="mt-auto inline-flex items-center justify-center font-display font-bold tracking-widest text-sm px-7 py-3 rounded-xl w-full max-w-[200px] transition-all duration-300 group-hover:-translate-y-1"
                style={{
                  background: c.btnBg || c.color,
                  color: c.btnText,
                  boxShadow: `0 10px 26px -10px ${c.color}99`,
                  border: c.btnBg ? `1px solid ${c.color}55` : 'none',
                }}
              >
                {c.cta}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
